<template>
  <v-layout fill-height column>
    <div class="question" v-html="ques[0].ques"></div>
    <div class="answer">

      <!-- 빈칸 채우기 긴글 -->
      <div class="solution-blank">
        <div class="solution-blank-start">
          <div class="text">{{ques[0].startQues}}</div>
        </div>
        <!--        <ResizeTextArea v-if="cmplt" :reply="textarea" @inputChanged="textareaVaule" read-only />-->
        <!--        <ResizeTextArea v-else :reply="textarea" @inputChanged="textareaVaule"/>-->
        <v-textarea flat solo no-resize auto-grow row="1" row-height="1"
                    hide-details
                    class="textarea"
                    placeholder="입력해주세요."
                    v-model="textarea"
                    :readonly="cmplt"
                    @input="textareaVaule"
        />
        <div class="solution-blank-end">
          <div class="text">{{ques[0].finishSay}}</div>
        </div>
      </div>
      <!-- // 빈칸 채우기 긴글 -->

    </div>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
// import ResizeTextArea from '@/components/forms/ResizeTextArea'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  data: () => ({
    disabledNext:true,
    free: 'N',
    cmplt:false,
    textarea:'',
    ques:[''],
    replyArr:[],
    replyObjArr:[],
    userReplyNo:[0],
    userReply:[],
  }),
  computed: {
  },
  components: {
    FooterBtnsNext,
    // ResizeTextArea
  },
  watch: {
    current(){
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.textarea='',
      this.disabledNext=true,
      this.free= 'N',
      this.cmplt=false,
      this.ques=[''],
      this.replyArr=[],
      this.replyObjArr=[],
      this.userReplyNo=[0],
      this.userReply=[],
      this.getUnitDetailUse()
    }
  },
  created () {
    this.getUnitDetailUse()
  },
  methods:{
    async getUnitDetailUse () {
      // 유닛 사용 번호
      // console.log('unitUseNo : ', this.unitUseNo)
      // 유닛상세 사용 번호
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo)
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo[this.current-1])
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq)
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq[this.current-1])

      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      // console.log('this.free : ', this.free)
      // console.log('this.cmplt : ', this.cmplt)

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
            {'freeYn':this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl,i) => {

              // 질문 셋팅
              this.ques.splice(0, this.ques.length);
              this.ques.push(quesEl)
              // console.log("this.ques : ",this.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });
              // console.log("this.replyArr : ",this.replyArr)
              // console.log("this.replyObjArr : ",this.replyObjArr)

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                this.textarea = userReplyEl.reply
                this.textareaVaule(this.textarea)
              });
            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅

        // 문장완성 답변
        let replyObj = this.replyObjArr[0]
        this.userReply[0] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

                                memberUnitDtlReplyUseNo: this.userReplyNo[0],
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: this.textarea,
                                // score: score/10,
                                freeYn: this.free
                              }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    textareaVaule(value){
      this.textarea = value;
      if(this.textarea.trim() == "" || this.textarea.length > 200){
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    }
  }
};
</script>


<style lang="scss" scoped>
::v-deep.textarea textarea{
  width:100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  outline: none;
  //resize: none;
  padding: 0 0 0 0 !important;
  margin: 10px 0 !important;
  font-size: 20px;
  line-height: 32px;
  font-weight: 400;
  background: #fff;
}
.textarea textarea::placeholder{
  color: #000;;
}
</style>
